export class VigenciasAdministracionDocumentos {
    auditoriaFecha: string;
    auditoriaUsuario: string;
    codigo: string;
    codigoVigencia: string;
    descripcion: string;
    duracionVigencia: string;
    id: number;
    idTipoVigencia: string;
    idVigenciaAdministracionDocumento: string;
    indicadorHabilitado: boolean;
    indicadorTercero: boolean;
    ip: string;
    nombre: string;
    vigencia: string;
    auditoriaUsuarioSistema: string;
}

export class VigenciasSolicitudes {
    id: number;
    idVigenciaSolicitud: string;
    idVigenciaSolicitudReferencia: string;
    idFlujoVentaPaso: string;
    indicadorTipo: boolean;
    idTipoVigencia: string;
    duracionVigencia: string;
    indicadorHabilitado: boolean;
    auditoriaFecha: string;
    auditoriaUsuario: string;
    codigoPaso: string;
    paso: string;
    codigoVigencia: string;
    vigencia: string;
    ip: string;
}

export class ValidityEmployees {
    id: number;
    idVigenciaTercero: string;
    idTipoVigencia: string;
    duracionVigencia: string;
    indicadorHabilitado: boolean;
    auditoriaFecha: string;
    auditoriaUsuario: string;
    codigoVigencia: string;
    vigencia: string;
    codigoFuncionalidadControl: string;
    funcionalidadControl: string;
    ip: string;
    idFuncionalidadControl: string;
    auditoriaUsuarioSistema: string;
}

export class VigenciasSolicitudesReferencias {
    id: number;
    idVigenciaSolicitudReferencia: string;
    idVigenciaSolicitud: string;
    idTipoReferencia: string | { value: string, label: string } | null;
    idTipoVigencia: string | { label: string; value: string } | null;
    duracionVigencia: string;
    indicadorHabilitado: boolean;
    auditoriaFecha: string;
    auditoriaUsuario: string;
    codigoTipoReferencia: string;
    referencia: string;
    codigoVigencia: string;
    vigencia: string;
    ip: string;
    isNew: boolean;
    constructor(){
        this.id = null;
        this.idVigenciaSolicitudReferencia = '';
        this.idVigenciaSolicitud = '';
        this.idTipoReferencia = '';
        this.idTipoVigencia = '';
        this.duracionVigencia = '';
        this.indicadorHabilitado = false;
        this.auditoriaFecha = '';
        this.auditoriaUsuario = '';
        this.codigoTipoReferencia = '';
        this.referencia = '';
        this.codigoVigencia = '';
        this.vigencia = '';
        this.ip = '';
        this.isNew = false;
    }
}

export class VigenciasSolicitudesRespaldos {
    id: number;
    idVigenciaSolicitudRespaldo: string;
    idVigenciaSolicitud: string;
    idTipoRespaldo: string;
    idTipoVigencia: string;
    duracionVigencia: string;
    indicadorHabilitado: boolean;
    auditoriaFecha: string;
    auditoriaUsuario: string;
    codigoRespaldo: string;
    respaldo: string;
    codigoVigencia: string;
    vigencia: string;
    ip: string;
    isNew: boolean;
    constructor(){
        this.id = null;
        this.idVigenciaSolicitudRespaldo = '';
        this.idVigenciaSolicitud = '';
        this.idTipoRespaldo = '';
        this.idTipoVigencia = '';
        this.duracionVigencia = '';
        this.indicadorHabilitado = false;
        this.auditoriaFecha = '';
        this.auditoriaUsuario = '';
        this.codigoRespaldo = '';
        this.respaldo = '';
        this.codigoVigencia = '';
        this.vigencia = '';
        this.ip = '';
        this.isNew = false;
    }

}

export class TiposRespaldos {
    idTipoRespaldo: string;
    id: number;
    codigo: string;
    nombre: string;
    descripcion: string;
    indicadorHabilitado: boolean;
    auditoriaUsuario: string;
    auditoriaFecha: string;
    ip: string;
}

interface CampoConfig {
  control: string;
  nombreLegible: string;
  esVigencia?: boolean;
  esNatural?: boolean;
  esJuridico?: boolean;
}

export const camposConfig: { [key: string]: CampoConfig } = {
  // Campos de datos básicos
  'DBTIPD': { control: 'idTipoDocumento', nombreLegible: 'Tipo de Documento', esNatural: true, esJuridico: true },
  'DBNUMD': { control: 'numeroDocumento', nombreLegible: 'Número de Documento', esNatural: true, esJuridico: true },
  'DBDIGV': { control: 'digitoVerificacion', nombreLegible: 'Dígito de Verificación', esNatural: false, esJuridico: true },
  'DBCONT': { control: 'indicadorContrasena', nombreLegible: 'Contraseña', esNatural: true, esJuridico: false },

  // Campos persona natural
  'UFEDUC': { control: 'idNivelEducacion', nombreLegible: 'Nivel de Educación', esNatural: true, esJuridico: false },
  'DBPRNO': { control: 'primerNombre', nombreLegible: 'Primer Nombre', esNatural: true, esJuridico: false },
  'DBSENO': { control: 'segundoNombre', nombreLegible: 'Segundo Nombre', esNatural: true, esJuridico: false },
  'DBPRAP': { control: 'primerApellido', nombreLegible: 'Primer Apellido', esNatural: true, esJuridico: false },
  'DBSEAP': { control: 'segundoApellido', nombreLegible: 'Segundo Apellido', esNatural: true, esJuridico: false },
  'ETNIAT': { control: 'idEtnia', nombreLegible: 'Etnia', esNatural: true, esJuridico: false },
  'CPLNAC': { control: 'fechaNacimiento', nombreLegible: 'Fecha de Nacimiento', esNatural: true, esJuridico: false },
  'CPLLUG': { control: 'ciudadNacimiento', nombreLegible: 'Ciudad de Nacimiento', esNatural: true, esJuridico: false },
  'CPLEXP': { control: 'fechaDocumento', nombreLegible: 'Fecha de Expedición', esNatural: true, esJuridico: false },
  'CPLLEX': { control: 'ciudadExpDocumento', nombreLegible: 'Ciudad de Expedición', esNatural: true, esJuridico: false },
  'CPLGEN': { control: 'idGenero', nombreLegible: 'Género', esNatural: true, esJuridico: false },
  'CPLCIV': { control: 'idEstadoCivil', nombreLegible: 'Estado Civil', esNatural: true, esJuridico: false },
  'CPLSAN': { control: 'idFactorRh', nombreLegible: 'Factor Rh', esNatural: true, esJuridico: false },

  // Campos persona jurídica
  'CPLSOC': { control: 'idTipoSociedad', nombreLegible: 'Tipo de Sociedad', esNatural: false, esJuridico: true },
  'CPLJUR': { control: 'idEstadoJuridico', nombreLegible: 'Estado Jurídico', esNatural: false, esJuridico: true },
  'CPLRSO': { control: 'razonSocial', nombreLegible: 'Razón Social', esNatural: false, esJuridico: true },
  'CPLNOC': { control: 'nombreComercial', nombreLegible: 'Nombre Comercial', esNatural: false, esJuridico: true },
  'CPLPECO': { control: 'personaContacto', nombreLegible: 'Persona Contacto', esNatural: false, esJuridico: true },
  'CPLORD': { control: 'idEntidadOrdenTerritorial', nombreLegible: 'Entidad Orden Territorial', esNatural: false, esJuridico: true },
  'CPLTIEM': { control: 'idTipoEmpresa', nombreLegible: 'Tipo Empresa', esNatural: false, esJuridico: true },
  'CPLCON': { control: 'fechaConstitucion', nombreLegible: 'Fecha Constitución', esNatural: false, esJuridico: true },
  'CPLTIEN': { control: 'idTipoEntidad', nombreLegible: 'Tipo Entidad', esNatural: false, esJuridico: true },
  'CPLPACO': { control: 'idPaisConstitucion', nombreLegible: 'Pais Constitución', esNatural: false, esJuridico: true },
  'CPLCICO': { control: 'ciudadConstitucion', nombreLegible: 'Ciudad Constitución', esNatural: false, esJuridico: true },
  'CPLDIG': { control: 'digitoVerificacion', nombreLegible: 'Dígito Verificación', esNatural: false, esJuridico: true },

  // Campos de contacto
  'CPLCOR': { control: 'correoElectronico', nombreLegible: 'Correo Electrónico', esNatural: true, esJuridico: false },
  'CPLCCO': { control: 'confirmarCorreoElectronico', nombreLegible: 'Confirmar Correo Electrónico', esNatural: true, esJuridico: false },
  'CPLCEL': { control: 'numeroTelefono', nombreLegible: 'Número de Teléfono', esNatural: true, esJuridico: false },
  'CPLTEL': { control: 'numeroTelefonoComercial', nombreLegible: 'Número de Teléfono Comercial', esNatural: true, esJuridico: true },
  'DACOCO': { control: 'correoCorporativo', nombreLegible: 'Correo Corporativo', esNatural: true, esJuridico: true },
  'CPLCCE': { control: 'confirmarNumeroTelefono', nombreLegible: 'Confirmar Número de Teléfono', esNatural: true, esJuridico: true },
  'DACOTE': { control: 'numeroTelefonoComercial', nombreLegible: 'Número de Teléfono Comercial', esNatural: true, esJuridico: true },

  // Campos de dirección
  'DBMUBA': { control: 'barrio', nombreLegible: 'Barrio/Vereda', esNatural: true, esJuridico: true },
  'CPLDIR': { control: 'direccion', nombreLegible: 'Dirección', esNatural: true, esJuridico: true },
  'DIRRECION': { control: 'direccion', nombreLegible: 'Dirección', esNatural: true, esJuridico: true },
  'DANEG': { control: 'direccionNegocio', nombreLegible: 'Dirección Negocio', esNatural: true, esJuridico: true },
  'DAHOG': { control: 'direccionHogar', nombreLegible: 'Dirección Hogar', esNatural: true, esJuridico: true },

  // Campos de operaciones
  'OPMOEX': { control: 'indicadorMonedaExtranjera', nombreLegible: 'Operaciones en Moneda Extranjera', esNatural: true, esJuridico: true },
  'CPPRLE': { control: 'indicadorOperacionTarjeta', nombreLegible: 'Preguntas Legales / PEP', esNatural: true, esJuridico: true },
  'UFOPER': { control: 'indicadorOperacionTarjeta', nombreLegible: 'Operaciones en Moneda Extranjera', esNatural: true, esJuridico: true },
  'UFIPEP': { control: 'indicadorPEP', nombreLegible: 'Persona Expuesta Políticamente (PEP)', esNatural: true, esJuridico: true },
  'UFREPE': { control: 'indicadorRelacionPEP', nombreLegible: 'Relación con Persona Expuesta Políticamente', esNatural: true, esJuridico: true },
};

export const camposAdicionales: string[] = [
    'idTipoPersona',
    'indicadorSolicitudDigital',
];

export const camposNollenar: string[] = [
    'idTituloProfesional',
    'parentescos',
];

export const noSincronizar: string[] = [
    'confirmarCorreoElectronico',
    'confirmarNumeroTelefono',
];

export const procesarSoloNatural: string[] = [
    'idNivelEducacion',
];

export const camposDupParaJuridicosBasicos: string[] = [
    'DBTIPD',
    'DBNUMD',
    'DBPRNO',
    'DBSENO',
    'DBPRAP',
    'DBSEAP',
    'INPAAC',
    'CPLCOR',
    'CPLTEL',
    'DACOCO',
    'DACOTE'
];

export const camposDupParaJuridicosComplementarios: string[] = [
    'DBTIPD',
    'DBNUMD',
];

export const camposCondicionales: { campo: string; codigoPadre: string; campoDependiente: string | null }[] = [
  { campo: 'idBarrio', codigoPadre: 'DBMUBA', campoDependiente: null },
  { campo: 'idTipoUso', codigoPadre: 'CPLCEL', campoDependiente: null },
  { campo: 'idTipoTelefono', codigoPadre: 'CPLCEL', campoDependiente: null },
  { campo: 'idTipoUsoTelefono', codigoPadre: 'CPLCEL', campoDependiente: null },
  { campo: 'idTipoTelefonoComercial', codigoPadre: 'DACOTE', campoDependiente: null },
  { campo: 'idCiudadNacimiento', codigoPadre: 'CPLLUG', campoDependiente: null },
  { campo: 'idCiudadExpDocumento', codigoPadre: 'CPLLEX', campoDependiente: null },
  { campo: 'idCiudadConstitucion', codigoPadre: 'CPLCICO', campoDependiente: null },
  { campo: 'idTituloProfesional', codigoPadre: 'UFEDUC', campoDependiente: null },
  { campo: 'confirmarCorreoElectronico', codigoPadre:'CPLCOR', campoDependiente: 'CPLCCO' },
  { campo: 'confirmarNumeroTelefono', codigoPadre:'CPLCEL', campoDependiente: 'CPLCCE' },
  { campo: 'direccionNegocio', codigoPadre: 'CPLDIR', campoDependiente: null },
  { campo: 'direccionHogar', codigoPadre: 'CPLDIR', campoDependiente: null },
  { campo: 'idTipoOperacionComercial', codigoPadre: 'OPMOEX', campoDependiente: null },
  { campo: 'tipoOperacionOtro', codigoPadre: 'OPMOEX', campoDependiente: null },
  { campo: 'entidad', codigoPadre: 'OPMOEX', campoDependiente: null },
  { campo: 'idTipoCuentaBancaria', codigoPadre: 'OPMOEX', campoDependiente: null },
  { campo: 'tipoCuentaBancariaOtro', codigoPadre: 'OPMOEX', campoDependiente: null },
  { campo: 'montoMensual', codigoPadre: 'OPMOEX', campoDependiente: null },
  { campo: 'idPais', codigoPadre: 'OPMOEX', campoDependiente: null },
  { campo: 'idMoneda', codigoPadre: 'OPMOEX', campoDependiente: null },
  // Campos condicionales para CPPRLE
  { campo: 'indicadorOperacionTarjeta', codigoPadre: 'CPPRLE', campoDependiente: null },
  { campo: 'indicadorPEP', codigoPadre: 'CPPRLE', campoDependiente: null },
  { campo: 'indicadorRelacionPEP', codigoPadre: 'CPPRLE', campoDependiente: null },
  { campo: 'idTipoOperacionComercial', codigoPadre: 'CPPRLE', campoDependiente: null },
  { campo: 'cualOperacion', codigoPadre: 'CPPRLE', campoDependiente: null },
  { campo: 'idEntidadBancaria', codigoPadre: 'CPPRLE', campoDependiente: null },
  { campo: 'idTipoCuentaBancaria', codigoPadre: 'CPPRLE', campoDependiente: null },
  { campo: 'cualProducto', codigoPadre: 'CPPRLE', campoDependiente: null },
  { campo: 'monto', codigoPadre: 'CPPRLE', campoDependiente: null },
  { campo: 'idDivisionPolitica', codigoPadre: 'CPPRLE', campoDependiente: null },
  { campo: 'idMoneda', codigoPadre: 'CPPRLE', campoDependiente: null }
];

export const camposEmpresa = ['CPLRSO', 'CPLNOC', 'CPLTIEM', 'CPLORD', 'CPLCON', 'CPLPACO', 'CPLCICO', 'CPLSOC', 'CPLTIEN', 'DACOCO', 'DACOTE'];
export const camposComplementariosJuridicosVigencia = ['OPMOEX'];
export const camposPreguntasLegalesVigencia = ['CPPRLE', 'UFOPER', 'UFIPEP', 'UFREPE'];

export const controlesRequeridos = [
  'idTipoOperacionComercial',
  'idEntidadBancaria',
  'idTipoCuentaBancaria',
  'monto',
  'idMoneda',
  'idDivisionPolitica'
];

export const camposLimpiar = [
  'idTipoOperacionComercial',
  'cualOperacion',
  'idEntidadBancaria',
  'idTipoCuentaBancaria',
  'cualProducto',
  'monto',
  'idMoneda',
  'idDivisionPolitica'
];

export const controlesRequeridosMonedaExtranjeraNatural = controlesRequeridos;
export const camposLimpiarMonedaExtranjeraNatural = camposLimpiar;

